import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import LANGUAGE_CONTROLLER from '../../controllers/languages';
import GlobalFilterPanel, { FILTER_PERIOD_GROUP, FIELDS as GlobalFilterPanelFields } from '../filter/GlobalFilterPanel';
import { SSelect } from "@avalara/skylab-sdk/react";
import Logger, { LOG_LEVELS } from '../../utils/logger';

const log = new Logger('DATA_MINING_FILTER_PANEL', LOG_LEVELS.DEBUG);
const DEFAULT_FILTER_SETTING = {
    filterPeriodGroup: FILTER_PERIOD_GROUP.MONTH_YEAR,
    fieldOptions: {},
    hideElements: {
        startDate: true,
        endDate: true,
        countryCode: true,
        companyId: true,
        returnType: true,
        returnStatus: true
    }
};

class DataMiningFilterPanel extends Component {

    constructor(props) {
        super(props);
        let selection = {
            year: this.getYear(),
            reportType: props.reportType || '',
            month: this.getMonth()
        };
        this.state = {
            selection: selection,
            filterSetting: DEFAULT_FILTER_SETTING
        };
        this.onFieldChangeHandlerFactory = this.onFieldChangeHandlerFactory.bind(this);
        this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
    }

    onSearchClickHandler(selection) {
        log.debug('onSearchClickHandler(): state.selection: ', this.state.selection);
        log.debug('onSearchClickHandler(): selection: ', selection);
        let combinedSelection = Object.assign({}, this.state.selection, selection);
        log.debug('onSearchClickHandler(): combinedSelection: ', combinedSelection);
        this.props.onApply(combinedSelection);
    }

    getFilterSetting(reportType = '', dateRange = {}) {
        let filterSetting = {
            fieldOptions: {}
        };
        switch (reportType) {
            // TODO change to enum
            case "File processing log":
                filterSetting.hideElements = {
                    month: true,
                    year: true,
                    countryCode: true,
                    companyId: true,
                    returnType: true,
                    returnStatus: true
                };
                filterSetting.filterPeriodGroup = FILTER_PERIOD_GROUP.DATE_RANGE;
                filterSetting.adaptPeriodOptions = {
                    customDateRangeProvider: (selection) => {
                        let customDateRange = {};
                        let selectionEndDate = dateRange && dateRange.endDate ? moment.utc(dateRange.endDate) : (selection.endDate ? moment.utc(selection.endDate) : moment.utc(new Date()));
                        customDateRange.endDate = selectionEndDate;
                        customDateRange.startDate = dateRange && dateRange.startDate ? moment.utc(dateRange.startDate) : moment.utc(selectionEndDate).subtract(1, 'days');
                        return customDateRange;
                    }
                }
                break;
            case "Changes log":
            case "Delete log":
                filterSetting.hideElements = {
                    month: true,
                    year: true,
                    countryCode: true,
                    returnType: true,
                    returnStatus: true
                };
                filterSetting.filterPeriodGroup = FILTER_PERIOD_GROUP.DATE_RANGE;
                filterSetting.fieldOptions[GlobalFilterPanelFields.PARAM_COMPANY_ID] = {
                    useCompanyCode: true
                };
                filterSetting.adaptPeriodOptions = {
                    customDateRangeProvider: (selection) => {
                        let customDateRange = {};
                        let selectionEndDate = selection.endDate ? moment.utc(selection.endDate) : moment.utc(new Date());
                        customDateRange.endDate = selectionEndDate;
                        customDateRange.startDate = moment.utc(selectionEndDate).subtract('1', 'month');
                        return customDateRange;
                    }
                }
                break;
            case "VAT code history":
                const extraOptions = [{ value: 'Generic', body: 'Generic' }];
                filterSetting.hideElements = {
                    month: true,
                    year: true,
                    countryCode: true,
                    startDate: true,
                    endDate: true,
                    returnType: true,
                    returnStatus: true
                };
                filterSetting.filterPeriodGroup = FILTER_PERIOD_GROUP.DATE_RANGE;
                filterSetting.fieldOptions[GlobalFilterPanelFields.PARAM_COMPANY_ID] = {
                    useCompanyCode: true,
                    customOptions: extraOptions,
                };
                break;
            default:
                filterSetting = DEFAULT_FILTER_SETTING;
        }
        return filterSetting;
    }

    getYear() {
        var today = new Date();
        var yyyy = today.getFullYear();
        return yyyy;
    }

    getMonth() {
        //Method to get today -1 month
        // In Date, month start as 0=January, 1=February etc.
        var today = new Date();
        var mm = today.getMonth();
        return mm;
    }

    onFieldChangeHandlerFactory(evt) {
        log.debug('onFieldChangeHandlerFactory() Value', evt.detail.item.value);
        let selection = Object.assign({}, this.state.selection);
        selection.reportType = evt.detail.item.value;
        let filterSetting = this.getFilterSetting(selection.reportType) || DEFAULT_FILTER_SETTING;
        this.setState({ selection: selection, filterSetting: filterSetting });
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(selection);
        }
    }

    getReturnTypeOptions() {
        const reportTypes = [
            "dataMining_InvoiceLines",
            "dataMining_IntrastatLines",
            "dataMining_ChangesLogLines",
            "dataMining_DeleteLog",
            "dataMining_ReportingCombinationsHistory",
            "dataMining_GLStatusOverviewVRSide",
            "dataMining_GLStatusOverviewGLSide",
            "dataMining_ProcessingLog",
            "dataMining_SiiTransactions",
            "dataMining_SIILog",
            "MTDLiability",
            "MTDPayments",
            "MTDObligations"
        ];

        let reportTypeOptionsList = [{
            label: LANGUAGE_CONTROLLER.format(this.props.languages, "dataMining_SelectReportType"),
            value: "",
            selected: !this.state.selection.reportType ? true : false
        }];

        reportTypes.forEach((val) => {
            let intlVal = LANGUAGE_CONTROLLER.format(this.props.languages, val);
            reportTypeOptionsList.push({
                label: intlVal,
                value: intlVal,
                selected: this.state.selection.reportType === intlVal ? true : false
            });
        });

        return reportTypeOptionsList;
    }

    componentDidMount() {
        const selectValue = this.props.selectValue || {};
        if (!_.isEmpty(selectValue)) {
            let selection = Object.assign({}, this.state.selection, { 'reportType': this.props.reportType });
            const dateRange = {};
            if (selectValue.startDate && moment.utc(selectValue.startDate, 'YYYY-MM-DD').isValid()) {
                dateRange.startDate = moment.utc(selectValue.startDate, 'YYYY-MM-DD');
            }
            if (selectValue.endDate && moment.utc(selectValue.endDate, 'YYYY-MM-DD').isValid()) {
                dateRange.endDate = moment.utc(selectValue.endDate, 'YYYY-MM-DD');
            }
            this.setState({ selection: selection, filterSetting: this.getFilterSetting(this.props.reportType, dateRange) });
        }
    }

    render() {
        log.debug("render(): ");
        const filterSetting = this.state.filterSetting || DEFAULT_FILTER_SETTING;
        let selection = Object.assign({}, this.state.selection);
        return (
            <s-box name="filter-panel">
                <GlobalFilterPanel
                    {...filterSetting}
                    onSearchClick={this.onSearchClickHandler}
                    disableSearch={_.isEmpty(this.state.selection && this.state.selection.reportType)}
                >
                    <fieldset>
                        <label className="mr20"><span>{LANGUAGE_CONTROLLER.format(this.props.languages, 'dataMining_ReportType')}</span></label>
                        <SSelect defaultValue={this.state.selection.reportType} 
                            inputId="single-reportType-select"
                            name="reporttype"
                            onS-select={this.onFieldChangeHandlerFactory.bind(this)}
                            optionsList={this.getReturnTypeOptions() || []}
                            multiple={false}
                            showSelectionCount={false}
                        />
                        {/*Show only options for which have reports, hence commenting remaining */}
                        {/*<option><LanguageStringResolver string='dataMining_ErrorLines'/></option>*/}
                        {/*<option><LanguageStringResolver string='dataMining_OutputVATPerPeriod'/></option>*/}
                        {/*<option><LanguageStringResolver string='dataMining_InputVATPerPeriod'/></option>*/}
                        {/*<option><LanguageStringResolver string='dataMining_UnusualDataInvoiceDateWeekend'/></option>*/}
                        {/*<option><LanguageStringResolver string='dataMining_UnusualDataInvoiceWithTaxableBasisWhole1000'/></option>*/}
                        {/*<option><LanguageStringResolver string='dataMining_UnusualDataInvoiceDateAndReportingDateInDifferentPeriod'/></option>*/}
                        {/*<option><LanguageStringResolver string='dataMining_TaxCodeUsageTaxCodesUsedPerCustomer'/></option>*/}
                        {/*<option><LanguageStringResolver string='dataMining_TaxCodeUsageTaxCodesUserPerVendor'/></option>*/}
                        {/*<option><LanguageStringResolver string='dataMining_DistanceSalesReportBeforeTheshold'/></option>*/}
                        {/*<option><LanguageStringResolver string='dataMining_DistanceSalesReportAfterTreshold'/></option>*/}

                    </fieldset>

                </GlobalFilterPanel>

                <div className="clear"></div>
            </s-box>
        );
    }
}


DataMiningFilterPanel.defaultProps = {
    onApply: () => { },
    selectValue: {},
    onChange: () => { }
}

function mapStateToProps(state) {
    return {
        languages: state.languages
    }
}

// Wrap the component to inject state into it
export default connect(mapStateToProps)(DataMiningFilterPanel);
